import { Term, Track } from '../../../components/ui';
import type { GlossaryKey } from '../../../lib/glossary';
interface Signals {
  trend: number;
  recency: number;
  weak_chapters: number;
  engagement: number;
}

interface Props { signals: Signals; }

const HELP: Record<keyof Signals, GlossaryKey> = {
  trend: 'risk_trend', recency: 'risk_recency', weak_chapters: 'risk_weak_chapters', engagement: 'risk_engagement',
};

const ROWS: Array<{ key: keyof Signals; label: string }> = [
  { key: 'trend',          label: 'Trend' },
  { key: 'recency',        label: 'Recency' },
  { key: 'weak_chapters',  label: 'Weak chapters' },
  { key: 'engagement',     label: 'Engagement' },
];

/** Artboard `.fac` rows: biggest contributor first, an accent bar out of 25 and "+points" on the right. */
export default function RiskSignalBars({ signals }: Props) {
  const rows = ROWS.map((r) => ({ ...r, value: signals[r.key] })).sort((a, b) => b.value - a.value);
  return (
    <div className="text-sm">
      {rows.map((r) => {
        const pct = Math.max(0, Math.min(100, (r.value / 25) * 100));
        return (
          <div key={r.key} className="grid grid-cols-[minmax(0,1fr)_84px_34px] items-center gap-2.5 py-1.5 text-[13px]">
            <span className="text-ink"><Term k={HELP[r.key]}>{r.label}</Term></span>
            <Track value={pct} tone="accent" label={r.label} />
            <span className="text-right font-mono font-medium text-ink">+{r.value.toFixed(0)}</span>
          </div>
        );
      })}
    </div>
  );
}
